import { get } from '@/helpers/httpHandler';

export default {
  namespaced: true,

  state: {
    lang:
      localStorage.getItem('locale') || process.env.VUE_APP_I18N_LOCALE || 'de'
  },

  getters: {
    lang: state => {
      return state.lang;
    }
  },

  mutations: {
    lang: (state, lang) => {
      state.lang = lang;
    }
  },

  actions: {
    retrieveLanguages: () => get(`/languages`)
  }
};
